// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"303":"cbbb48f7","556":"f6f5e598"}[chunkId] + ".chunk.css";
};